import { Component } from '@angular/core';
import { DetectPlatformService } from '../../services/detectPlatform.service';

@Component({
  selector: 'download-app-warning',
  templateUrl: './download-app.component.html',
  styleUrls: ['./download-app.component.scss'],
})
export class DownloadAppComponent {
  constructor(public detectPlatformService: DetectPlatformService) {}

  get platform() {
    return this.detectPlatformService.getPlatform();
  }
}
